import {
  GET_INSTALLMENT_PLANS_ELIGIBILITY,
  GET_INSTALLMENT_PLANS_ELIGIBILITY_SUCCESS,
  GET_INSTALLMENT_PLANS_ELIGIBILITY_FAILURE,
} from '../actions/installmentPlans';

/**
 * @type {import('../types/state/installmentPlansState').InstallmentPlansState}
 */
const INITIAL_STATE = {
  plan: null,
  loading: true,
  error: null,
};

const reducers = {
  [GET_INSTALLMENT_PLANS_ELIGIBILITY]: state => ({
    ...state,
    loading: true,
    error: null,
  }),
  [GET_INSTALLMENT_PLANS_ELIGIBILITY_SUCCESS]: (state, { payload }) => ({
    ...state,
    plan: payload,
    loading: false,
    error: null,
  }),
  [GET_INSTALLMENT_PLANS_ELIGIBILITY_FAILURE]: (state, { payload }) => ({
    ...state,
    plan: null,
    loading: false,
    error: payload,
  }),
};

export default function installmentPlansReducer(state = INITIAL_STATE, action) {
  return (
    reducers[action.type]
      ? reducers[action.type](state, action)
      : state
  );
}
